import React from 'react';
import {
	MDBRow as Row,
	MDBCol as Col,
	MDBContainer as Container,
	MDBCarousel as Carousel,
	MDBCarouselInner as CarouselInner,
	MDBCarouselItem as CarouselItem,
	MDBView as View,
	MDBMask as Mask
} from 'mdbreact';

const About = () => {
	return (
		<section id='about' style={{ position: 'relative', top: '-220px' }}>
			<Container>
				<Row>
					<Col>
						<h1
							data-aos='fade-up'
							data-aos-delay='50'
							style={{ color: '#059E03' }}
							className='h1-responsive font-weight-bold mt-5 text-center text-uppercase'>
							ABOUT US
						</h1>
						<p
							data-aos='fade-up'
							data-aos-delay='200'
							className='lead grey-text w-responsive mx-auto mb-5 text-center'>
							Anong hanap mo, suki? Meron kami niyan!
						</p>
					</Col>
				</Row>
				<Row className='my-5'>
					<Col md='6' className='mb-5'>
						<Carousel
							data-aos='fade-right'
							data-aos-delay='500'
							activeItem={1}
							length={3}
							showControls={true}
							showIndicators={true}
							className='z-depth-2'>
							<CarouselInner>
								<CarouselItem itemId='1'>
									<View>
										<img
											className='d-block w-100 rounded'
											src='market1.jpeg'
											alt='First slide'
										/>
									</View>
								</CarouselItem>
								<CarouselItem itemId='2'>
									<View>
										<img
											className='d-block w-100 rounded'
											src='market2.jpeg'
											alt='Second slide'
										/>
									</View>
								</CarouselItem>
								<CarouselItem itemId='3'>
									<View>
										<img
											className='d-block w-100 rounded'
											src='market3.jpeg'
											alt='Third slide'
										/>
									</View>
								</CarouselItem>
							</CarouselInner>
						</Carousel>
					</Col>
					<Col md='6' className='d-flex align-items-center'>
						<div data-aos='fade-left' data-aos-delay='500'>
							<h5
								style={{ lineHeight: '150%' }}
								className='w-responsive mx-auto mb-5'>
								Mega Q Mart is an established wet & dry drop-off market
								(bagsakan) along the busy highway of Edsa, Cubao. It is famous
								for its cheap and farm-direct fresh produce coming from up
								north. We value cleanliness and safety, that is why we have
								sanitation and security personnel on-duty 24/7.
							</h5>
						</div>
					</Col>
				</Row>
				<Row className='my-5'>
					<Col md='6' className='d-flex align-items-center'>
						<div data-aos='fade-right' data-aos-delay='500'>
							<h5
								style={{ lineHeight: '150%' }}
								className='w-responsive mx-auto mb-5 text-right'>
								Layunin naming gawing “stress-free” ang inyong pamamalengke kaya
								kami na ang pipili, bibili, at maghahatid ng inyong mga
								produkto. Mas madali, mas maginhawa!
							</h5>
							<h5
								style={{ lineHeight: '150%' }}
								className='w-responsive mx-auto mb-5 text-right'>
								We aim to contribute to the local market’s growth and enliven
								the trade in terms of sourcing and providing fresh market
								produce through a cost-effective, hassle-free delivery service.
							</h5>
						</div>
					</Col>
					<Col md='6' className='mb-5'>
						<View
							hover
							rounded
							className='z-depth-1-half mb-4'
							data-aos='fade-left'
							data-aos-delay='500'>
							<img className='img-fluid' src='sharing-food.jpg' alt='' />
							<a href='#!'>
								<Mask overlay='white-slight' className='waves-light' />
							</a>
						</View>
					</Col>
				</Row>
			</Container>
			<View
				src={`delivery.jpeg`}
				data-jarallax='{"speed": 0.2}'
				className='jarallax h-50'>
				<Mask pattern={1}>
					<Mask
						className='d-flex justify-content-center align-items-center'
						overlay='black-strong'>
						<Row>
							<Col className='px-4'>
								<h3
									data-aos='fade-up'
									data-aos-delay='80'
									style={{ lineHeight: '150%' }}
									className='w-responsive mx-auto text-center white-text text-uppercase font-weight-bold'>
									Our mission is to offer{' '}
									<span style={{ color: '#00CC00' }}>convenient</span> shopping
									through a{' '}
									<span style={{ color: '#00CC00' }}>delivery service</span>{' '}
									that sources and supplies{' '}
									<span style={{ color: '#00CC00' }}>
										fresh market produce.
									</span>
								</h3>
							</Col>
						</Row>
					</Mask>
				</Mask>
			</View>
		</section>
	);
};

export default About;
